import useBookmarkItem from './useBookmarkItem';

const BookmarkLinkImage = (props: { link: string }) => {
  return useBookmarkItem(props.link);
};

export default BookmarkLinkImage;
